import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ChartsDataConfig from "../components/settings/ChartsDataConfig";

const Settings = () => {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Settings</title>
            </Helmet>
            <ChartsDataConfig />
        </div>
    );
};

export default Settings;
